import { render, staticRenderFns } from "./ScoresModal.vue?vue&type=template&id=3a481905&scoped=true&"
import script from "./ScoresModal.vue?vue&type=script&lang=js&"
export * from "./ScoresModal.vue?vue&type=script&lang=js&"
import style0 from "./ScoresModal.vue?vue&type=style&index=0&id=3a481905&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a481905",
  null
  
)

export default component.exports